<app-page-heading
  pageTitle="rData Records"
  pageDescription="Browse individual physician employment contract data."
></app-page-heading>
<app-page-well>
  <div class="filters-button" >
    <button lib-button theme="secondary" size="full-width" (click)="toggleFilters()">
      <span class="filters-button-text">{{showFilters() === true ? 'Hide Filters' : 'Filters'}}</span>
    </button>
  </div>

  <div class="filters"
    [ngClass]="{'hide': showFilters() === false}">
    <div class="r-data__field">
      <div>
        <app-multiselect
          inputId="specialtiesDropdown"
          name="specialties-dropdown"
          label="Specialties"
          placeholder="All available specialties"
          [optionGroup$]="userSpecialties$"
          [disabledGroup$]="disabledSpecialties$"
          [disabledLabel]="'Additional Specialties'"
          [selectedOptions]="specialties"
          (optionsChange)="selectSpecialty($event)"
        >
        </app-multiselect>
      </div>
    </div>
    <div class="r-data__field">
      <app-multiselect
        inputId="statesDropdown"
        name="states-dropdown"
        label="States"
        placeholder="All available states"
        [optionGroup$]="userStates$"
        [disabledGroup$]="disabledStates$"
        [disabledLabel]="'Additional States'"
        [selectedOptions]="states"
        (optionsChange)="selectState($event)"
      >
      </app-multiselect>
    </div>
    <div class="r-data__field">
      <app-multiselect
        inputId="practiceTypesDropdown"
        name="practice-types-dropdown"
        label="Practice Types"
        placeholder="All practice types"
        [optionGroup$]="practiceTypes$"
        [selectedOptions]="practiceTypes"
        (optionsChange)="selectPracticeType($event)"
      >
      </app-multiselect>
    </div>
    <div class="r-data__field">
      <app-grouped-select-menu
        inputId="positionTypesDropdown"
        name="position-types-dropdown"
        label="Position Type"
        placeholder="All position types"
        [optionGroup]="positionTypes$ | async"
        [selectedOption]="positionType"
        (changeEvent)="selectPositionType($event)"
      >
      </app-grouped-select-menu>
    </div>
    <div class="r-data__field">
      <lib-toggle
        label="Verified Contracts Only"
        [isChecked]="isVerified"
        [fullWidth]="true"
        formId="verified-toggle"
        (toggleEvent)="toggleVerified()"
      >
      </lib-toggle>
    </div>
  </div>
</app-page-well>

<app-page-well>
  <lib-rdata-results
    [results]="rDataRecords$"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    [showAd]="false"
    (pageChange)="onPageChanged($event)"
    (sortChange)="onSortChanged($event)"
  >
  </lib-rdata-results>
</app-page-well>


<lib-alert
  class="cta-alert"
  type="info"
  [centerContent]="true"
  [dismissible]="false"
  [show]="true"
  [showIcon]="true"
>
  <span
    >Contact your sales representative to unlock additional specialties and
    regions.</span
  >
</lib-alert>
